if(document.querySelector('.schedule')) {
    let url = new URL(window.location.href)
    let conf = url.searchParams.get('id')

    function updateSchedule() {
        requestAxios('scheduleData', {conf}, (res) => {
            let {date, selected} = res
            let structure = []
            let from = 7
            let to = 22
            let append = document.querySelector('.day-planing-hours')
    
            for(let i = from; i <= to; i++) {
                let next = (i + 1) < 10 ? '0' + (i + 1) : i + 1
                let key = i < 10 ? '0' + i : i
                let before = key + ':00'
                let after = next + ':00'
                let row = []

                for(let i = 0; i <= 1; i++) {
                    let classes = ['hour-item']
                    let mins = 30 * i
                    let nextMins = '00'
                    let nextHours = next
                    let text = ''
    
                    if(!mins) {
                        mins = '00'
                        nextMins = 30
                        nextHours = key
                    }
    
                    let time = `${key}:${mins} - ${nextHours}:${nextMins}`
    
                    let itemDate = date + ' ' + key + ':' + mins + ':00'
    
                    if(selected[itemDate]) {
                        text = selected[itemDate]
    
                        classes.push('selected')
                    }

                    text += ' ' + time
    
                    row.push(`<div class="${classes.join(' ')}" data-date="${itemDate}">${text}</div>`)
                }
    
                before = '<div class="label before">' + before + '</div>'
                after = i == to ? '<div class="label after">' + after + '</div>' : ''
    
                structure.push(`
                    <div class="hour-row">
                        ${before}
                        ${row.join('')}
                        ${after}
                    </div>
                `)
            }
    
            structure = structure.join('')

            append.innerHTML = structure
        })
    }

    updateSchedule()

    setInterval(updateSchedule, 60000)
}